import { render, staticRenderFns } from "./TipoImpressaoCustomizada.vue?vue&type=template&id=ddbedd8c"
import script from "./TipoImpressaoCustomizada.vue?vue&type=script&lang=js"
export * from "./TipoImpressaoCustomizada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports